// https://www.kunkalabs.com/mixitup/docs/get-started/
import mixitup from 'mixitup';

$(document).ready(function () {
    // var initialFilter = 'all';
    // var hash = window.location.hash.replace(/^#/g, '');
    // if (hash) {
    //     initialFilter = '.' + hash;
    // }
    $('.mixitup-control').on('click', function () {
        var filter = $(this).attr('data-filter');

        if (filter == 'all') {
            $('.mixit--filter').removeClass('filter-active');

        } else {    
            $('.mixit--filter').addClass('filter-active');
        }
    });
    if ($('.mixit--filter').length) {
        var mixer = mixitup(".mixit--filter", {
            animation: {
                // animateResizeTargets: true,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            selectors: {
                control: '.mixitup-control'
            },
        });

        $('.post-button').on('click', function () {
            var tabID = $(this).attr('data-filter');
            // $(this).addClass('active').siblings().removeClass('active');
            if (tabID == 'all') {
                $('.mixit--text .mix').removeClass('active');
                $('.mixit--text .mix.filter--all').addClass('active').siblings().removeClass('active');
            } else {
                $('.mixit--text .mix').removeClass('active');
                $('.mixit--text ' + tabID).addClass('active').siblings().removeClass('active');
            }
        });
    }
});
